export default function checkCssProperty(element) {
  const computedStyle = window.getComputedStyle(element);
  if (computedStyle.display === 'contents') {
    // If display is 'contents', we return the direct children of the element
    const result = [];
    for (const child of element.children) {
      if (child instanceof HTMLElement) {
        result.push(child);
      }
    }
    return result;
  }
  return [element];
}